<h1 class="sr-only">{{t.pageTitle.genericTitle}}</h1>

<router-outlet></router-outlet>

<ng-container #dev></ng-container>
